import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'
// Import using ESM URL imports in environments that supports it:
// import {createClient} from 'https://esm.sh/@sanity/client'

export const client = createClient({
  projectId: '6hl3wilw',
  dataset: 'production',
  useCdn: true, // set to `false` to bypass the edge cache
  apiVersion: '2023-05-03'
  // token: process.env.SANITY_SECRET_TOKEN // Only if you want to update content with the client
})

const builder = imageUrlBuilder(client)

export function sanityImageUrl(source: string): any {
  return builder.image(source)
}

// uses GROQ to query content: https://www.sanity.io/docs/groq
export async function getPosts(): Promise<any> {
  const posts =
    await client.fetch(`*[_type == "post"] | order(publishedAt desc) {
    _id, slug, title, mainImage, author->{name}, publishedAt, excerpt, body
  }`)
  return posts
}
export async function getPost(slug: string): Promise<any> {
  const posts =
    await client.fetch(`*[_type == "post" && slug.current == "${slug}"]{
    _id, slug, title, mainImage, author->{name}, publishedAt, excerpt, body
  }`)

  return posts
}

// export async function createPost(post: Post) {
//   const result = client.create(post)
//   return await result
// }

// export async function updateDocumentTitle(_id, title) {
//   const result = client.patch(_id).set({ title })
//   return result
// }
